// extracted by mini-css-extract-plugin
export default {"container":"quality_container__oQdYZ"};